import appConfig from "@/app.config";

const schema = {
  tabs: [
    {
      title: 'Permissions',
      meta: [{ name: "description", content: appConfig.description }],
      name: "Permissions",
      activeBtn: true,
      addNewBtn: true,
      deleteBtn: true,
      addNewModalTitle: 'Add New Role',
      formData: {},
      schema: {
      name: {
        type: 'text',
        label: 'Role Title',
        placeholder: 'Enter Role Title',
        required: true,
        info: false,
        character_count: 50
        },
      },
      side_panel: {
        select_a_page: {
          type: 'list',
          label: 'Select Page',
          placeholder: '',
          required: false,
          info: true,
          character_count: 0,
          disabled: false,
          wrapper_class: '',
          options: []
        }
      },
      form: {}
    }
  ]
};

export { schema };